import { MODULE_NAMES } from '../../Constants/modules';

/* eslint-disable */
const modifyData = {
  View: 'read',
  Add: 'create',
  Edit: 'update',
  Delete: 'delete',
};

const viewEditData = {
  View: 'read',
  Edit: 'update',
};

export const tasks = {
  View: 'read',
  Add: 'create',
  Edit: 'update',
  Delete: 'delete',
};

export const pageConfig = {
  Home: {
    title: 'Home',
    active: false,
    content: {
      Dashboard: {
        module: MODULE_NAMES.HOME_DASHBOARD,
        actions: { View: modifyData.View },
        content: {
          'Account Based Report View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ACCOUNT_BASED_REPORT,
            actions: { View: modifyData.View },
          },
          'Senior Manager Filter View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ACCOUNT_BASED_FILTER,
            actions: { View: modifyData.View },
          },
          'Architect Dashboard View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ARCHITECT_REPORT,
            actions: { View: modifyData.View },
          },
          'Architect Filter View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ARCHITECT_FILTER,
            actions: { View: modifyData.View },
          },
          'Architect Technology View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ARCHITECT_TECHNOLOGY,
            actions: { View: modifyData.View },
          },
          'Architect Effort Deviation View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ARCHITECT_EFFORT_DEVIATION,
            actions: { View: modifyData.View },
          },
          'Architect Utilization View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ARCHITECT_UTILIZATION,
            actions: { View: modifyData.View },
          },
          'Architect RU Unit View': {
            module: MODULE_NAMES.HOME_DASHBOARD_ARCHITECT_RU_UNIT,
            actions: { View: modifyData.View },
          },
          'PM Dashboard View': {
            module: MODULE_NAMES.HOME_DASHBOARD_PM_REPORT,
            actions: { View: modifyData.View },
          },
          'PM Filter View': {
            module: MODULE_NAMES.HOME_DASHBOARD_PM_FILTER,
            actions: { View: modifyData.View },
          },
          'PM CSAT View': {
            module: MODULE_NAMES.HOME_DASHBOARD_PM_CSAT,
            actions: { View: modifyData.View },
          },
          'PM Quality Audit View': {
            module: MODULE_NAMES.HOME_DASHBOARD_PM_QUALITY_AUDIT,
            actions: { View: modifyData.View },
          },
          'PM PMO Audit View': {
            module: MODULE_NAMES.HOME_DASHBOARD_PM_PMO_AUDIT,
            actions: { View: modifyData.View },
          },
          'PM RU Unit View': {
            module: MODULE_NAMES.HOME_DASHBOARD_PM_RU_UNIT,
            actions: { View: modifyData.View },
          },
        },
      },
    },
  },
  Masters: {
    title: 'Masters',
    active: false,
    content: {},
    subMenu: {
      Delivery: {
        title: 'Delivery',
        isActive: false,
        content: {
          Role: {
            module: MODULE_NAMES.MASTER_DELIVERY_ROLE,
            actions: { ...modifyData },
          },
        },
      },
      Training: {
        title: 'Training',
        isActive: false,
        content: {
          Skill: {
            module: MODULE_NAMES.MASTER_TRAINING_SKILL,
            actions: { ...modifyData },
          },
          Certification: {
            module: MODULE_NAMES.MASTER_TRAINING_CERTIFICATION,
            actions: { ...modifyData },
          },
          'Certification Category': {
            module: MODULE_NAMES.MASTER_TRAINING_CERT_CATEGORY,
            actions: { ...modifyData },
          },
          Target: {
            module: MODULE_NAMES.CERTIFICATION_TARGET,
            actions: { ...modifyData },
          },
        },
      },
      Performance: {
        title: 'Performance',
        isActive: false,
        content: {
          'Declare performance period': {
            module: MODULE_NAMES.MASTER_PERFORMANCE_PERIOD,
            actions: { ...modifyData },
          },
          'Declare source & remark': {
            module: MODULE_NAMES.MASTER_REMARKS,
            actions: { ...modifyData },
          },
        },
      },
      DealTransition: {
        title: 'Deal transition',
        isActive: false,
        content: {
          'Deal Status': {
            module: MODULE_NAMES.MASTER_DEAL_STATUS,
            actions: { ...modifyData },
          },
          'Deal Role': {
            module: MODULE_NAMES.MASTER_DEAL_ROLE,
            actions: { ...modifyData },
          },
          'Parameters': {
            module: MODULE_NAMES.MASTER_DEAL_PARAMETERS,
            actions: { ...modifyData },
          },
          'Efforts': {
            module: MODULE_NAMES.MASTER_DEAL_EFFORTS,
            actions: { ...modifyData },
          },
          'Cost Master': {
            module: MODULE_NAMES.MASTER_COST_MASTER,
            actions: { ...modifyData },
          },
        },
      },
      StaffAugStatus: {
        title: 'StaffAug status',
        isActive: false,
        content: {
          'Requirement Status': {
            module: MODULE_NAMES.MASTER_STAFFAUG_REQUIREMENT_STATUS,
            actions: { ...modifyData },
          },
          'Client Interview Status': {
            module: MODULE_NAMES.MASTER_STAFFAUG_CLIENT_INTERVIEW,
            actions: { ...modifyData },
          },
          'Lost/ Dropped Status': {
            module: MODULE_NAMES.MASTER_STAFFAUG_LOST_DROPPED_STATUS,
            actions: { ...modifyData },
          },
          Geography: {
            module: MODULE_NAMES.MASTER_STAFFAUG_GEOGRAPHY,
            actions: { ...modifyData },
          },
        },
      },
      Configuration: {
        title: 'Configuration',
        isActive: false,
        content: {
          'Cloud Provider': {
            module: MODULE_NAMES.CONFIGURATION_CLOUD_PROVIDER,
            actions: { ...modifyData },
          },
          'Allocation Stakeholders': {
            module: MODULE_NAMES.MASTER_ALLOCATION_STAKE_HOLDERS,
            actions: { ...modifyData },
          },
          'Billing Type': {
            module: MODULE_NAMES.CONFIGURATION_BILLING_TYPE,
            actions: { ...modifyData },
          },
          'Region List': {
            module: MODULE_NAMES.MASTERS_REGION_LIST,
            actions: { ...modifyData },
          },
          'Invoice Type': {
            module: MODULE_NAMES.MASTERS_INVOICE_TYPE,
            actions: { ...modifyData },
          },
          'Department List': {
            module: MODULE_NAMES.CONFIGURATION_DEPARTMENT_LIST,
            actions: { ...modifyData },
          },
          'Employee Experience': {
            module: MODULE_NAMES.CONFIGURATION_EMPLOYEE_EXPERIENCE,
            actions: { ...modifyData },
          },
          'Country List': {
            module: MODULE_NAMES.MASTERS_COUNTRY_LIST,
            actions: { ...modifyData },
          },
          'Delivery Methodology': {
            module: MODULE_NAMES.MASTERS_DELIVERY_METHODOLGY,
            actions: { ...modifyData },
          },
          'Invoice Payment Status': {
            module: MODULE_NAMES.CONFIGURATION_INVOICE_PAYMENT_STATUS,
            actions: { ...modifyData },
          },
          'Employee Vertical': {
            module: MODULE_NAMES.CONFIGURATION_EMPLOYEE_VERTICAL,
            actions: { ...modifyData },
          },
          'Invoice Status': {
            module: MODULE_NAMES.CONFIGURATION_INVOICE_STATUS,
            actions: { ...modifyData },
          },
          'Issue Categories': {
            module: MODULE_NAMES.CONFIGURATION_ISSUE_CATEGORY,
            actions: { ...modifyData },
          },
          'Issue Status': {
            module: MODULE_NAMES.CONFIGURATION_ISSUE_STATUS,
            actions: { ...modifyData },
          }
        },
      },
    },
  },
  Users: {
    title: 'Users',
    active: false,
    content: {
      'User Management': {
        module: MODULE_NAMES.CONFIGURATION_USER,
        actions: { ...modifyData },
      },
    },
  },
  Skills: {
    title: 'Skills',
    active: false,
    content: {
      'Skill Mapping': {
        module: MODULE_NAMES.CONFIGURATION_SKILL,
        actions: { ...modifyData },
      },
    },
  },
  Certifications: {
    title: 'Certifications',
    active: false,
    content: {
      'Certifications Overview': {
        module: MODULE_NAMES.CERTIFICATION_OVERVIEW,
        actions: { ...modifyData },
      },
      'Certifications Mapping': {
        module: MODULE_NAMES.CERTIFICATION_MAP,
        actions: { ...modifyData },
      },
    },
  },
  Configurations: {
    title: 'Configurations',
    active: false,
    content: {
      'Manage KPI': {
        module: MODULE_NAMES.CONFIGURATION_MANAGE_KPI,
        actions: { ...modifyData },
      },
      'Data Upload': {
        title: 'Data Upload',
        active: false,
        content: {
          'Effort Upload': {
            module: MODULE_NAMES.CONFIGURATION_EFFORT_UPLOAD,
            actions: { ...modifyData },
          },
          'Leave Upload': {
            module: MODULE_NAMES.CONFIGURATION_LEAVE_UPLOAD,
            actions: { ...modifyData },
          },
          'File Upload': {
            module: MODULE_NAMES.CONFIGURATION_FILE_UPLOAD,
            actions: { ...modifyData },
          },
        },
      },
      'Date Config': {
        module: MODULE_NAMES.CONFIGURATION_DATE_CONFIG,
        actions: { ...modifyData },
      },
    },
  },
  GeneralConfig: {
    title: 'General Config',
    active: false,
    content: {
      Search: {
        module: MODULE_NAMES.GENERAL_CONFIG_SEARCH,
        actions: { ...modifyData },
      },
    },
  },
  EmployeeProfile: {
    title: 'Employee Profile',
    active: false,
    content: {
      Onboarding: {
        module: MODULE_NAMES.EMPLOYEE_ONBOARDING,
        actions: { ...modifyData },
      },
      'Skills, Awards and Certifications': {
        module: MODULE_NAMES.EMPLOYEE_ACHIEVEMENTS,
        actions: { ...modifyData },
      },
      'Trainings and Assessments': {
        module: MODULE_NAMES.EMPLOYEE_TRAINING,
        actions: { ...modifyData },
      },
      Projects: {
        module: MODULE_NAMES.EMPLOYEE_PROJECTS,
        actions: { ...modifyData },
      },
      Performance: {
        module: MODULE_NAMES.EMPLOYEE_PERFORMANCE,
        actions: { ...modifyData },
      },
    },
  },
  Delivery: {
    title: 'Delivery',
    active: false,
    content: {
      'Project Overview': {
        title: 'Project Overview',
        active: false,
        content: {
          'Project Details': {
            title: 'Project Details',
            active: false,
            content: {
              'Project Details View': {
                module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW,
                actions: { ...modifyData },
              },
              'Customer Type': {
                module: MODULE_NAMES.DELIVERY_PROJECT_DETAILS_CUSTOMER_TYPE,
                actions: { ...modifyData },
              },
              'VG / NVG': {
                module: MODULE_NAMES.DELIVERY_PROJECT_DETAILS_VG_NVG,
                actions: { ...modifyData },
              },
              'Effort Logging': {
                module: MODULE_NAMES.DELIVERY_PROJECT_DETAILS_EFFORT_LOGGING,
                actions: { ...modifyData },
              },
              'Jira Project Id': {
                module: MODULE_NAMES.DELIVERY_PROJECT_DETAILS_JIRA_PROJECT_ID,
                actions: { ...modifyData },
              },
              'Project DL': {
                module: MODULE_NAMES.DELIVERY_PROJECT_DETAILS_PROJECT_DL,
                actions: { ...modifyData },
              },
              'Project Billability': {
                module: MODULE_NAMES.DELIVERY_PROJECT_DETAILS_UTILIZATION,
                actions: { ...modifyData },
              },
            },
          },
          'Resource Loading Plan': {
            title: 'Resource Loading Plan',
            active: false,
            content: {
              'Resource Loading Plan Details': {
                module: MODULE_NAMES.DELIVERY_RESOURCE_LOADING_PLAN,
                actions: { ...modifyData },
              },
              'Resource Loading Approval History': {
                module: MODULE_NAMES.DELIVERY_RESOURCE_LOADING_APPROVAL_HISTORY,
                actions: { ...modifyData },
              },
            },
          },
          'Project – User Access': {
            module: MODULE_NAMES.DELIVERY_PROJECT_DETAILS_EDIT,
            actions: { ...modifyData },
          },
          'Project – Manager Access': {
            module: MODULE_NAMES.DELIVERY_PROJECT_MANAGER_DETAILS_EDIT,
            actions: { ...modifyData },
          },
          Risk: {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_RISK,
            actions: { ...modifyData },
          },
          Issue: {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_ISSUE,
            actions: { ...modifyData },
          },
          'Infosec Risk': {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_INFOSEC_RISK,
            actions: { ...modifyData },
          },
          CSAT: {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_CSAT,
            actions: { ...modifyData },
          },
          SGM: {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_SGM,
            actions: { ...modifyData },
          },
          EGM: {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_EGM,
            actions: { ...modifyData },
          },
          AGM: {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_AGM,
            actions: { ...modifyData },
          },
          'Resource Allocation Count': {
            module: MODULE_NAMES.DELIVERY_RESOURCE_ALLOCATION_COUNT,
            actions: { ...modifyData },
          },
          'Resource Allocation Details': {
            module: MODULE_NAMES.DELIVERY_RESOURCE_ALLOCATION_DETAILS,
            actions: { ...modifyData },
          },
          'Project Progress': {
            module: MODULE_NAMES.DELIVERY_PROJECT_PROGRESS,
            actions: { ...modifyData },
          },
          'RAG Status': {
            module: MODULE_NAMES.DELIVERY_RAG_STATUS,
            actions: { ...modifyData },
          },
          'Status Change Request': {
            module: MODULE_NAMES.DELIVERY_STATUS_HISTORY_APPROVAL,
            actions: { ...modifyData },
          },
          'Audit Score': {
            module: MODULE_NAMES.DELIVERY_AUDIT_SCORE,
            actions: { ...modifyData },
          },
          'Project Logged Effort Percentage View': {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_lAST_MONTH,
            actions: { ...modifyData },
          },
          'Effort Estimation': {
            module: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW_EFFORT_ESTIMATION,
            actions: { ...modifyData },
          },
          'Project Unit': {
            module: MODULE_NAMES.DELIVERY_PROJECT_UNIT,
            actions: { ...modifyData },
          },
          'Project Unit Amount': {
            module: MODULE_NAMES.DELIVERY_PROJECT_UNIT_AMOUNT,
            actions: { ...modifyData },
          },
          'Budget change request': {
            title: 'Budget change request',
            active: false,
            content: {
              Approve: {
                module: MODULE_NAMES.PROJECT_BUDGET_CHANGE_REQUEST_APPROVE,
                actions: { ...modifyData },
              },
              Efforts: {
                module: MODULE_NAMES.PROJECT_BUDGET_CHANGE_REQUEST_EFFORTS,
                actions: { ...modifyData },
              },
              Cost: {
                module: MODULE_NAMES.PROJECT_BUDGET_CHANGE_REQUEST_COST,
                actions: { ...modifyData },
              },
            },
          },
        },
      },
      'Staffing Request': {
        title: 'Staffing Request',
        active: false,
        content: {
          'Staffing Request View/Edit': {
            module: MODULE_NAMES.DELIVERY_ADD_STAFFING_REQUEST,
            actions: { ...modifyData },
          },
          'Staffing Request Approval': {
            module: MODULE_NAMES.DELIVERY_ADD_STAFFING_REQUEST_APPROVAL,
            actions: { ...modifyData },
          },
        },
      },
      'Project Info Lookup': {
        module: MODULE_NAMES.DELIVERY_PROJECT_INFO_LOOKUP,
        actions: { ...modifyData },
      },
      'Add Projects': {
        module: MODULE_NAMES.DELIVERY_ADD_PROJECTS,
        actions: { ...modifyData },
      },
    },
  },
  MIS: {
    title: 'MIS',
    active: false,
    content: {
      'Employee MIS': {
        module: MODULE_NAMES.MIS_EMPLOYEE_DETAILS,
        actions: { ...modifyData },
      },
      'Allocation MIS': {
        module: MODULE_NAMES.MIS_ALLOCATION_MIS,
        actions: { ...modifyData },
      },
      'Project Allocation %': {
        module: MODULE_NAMES.MIS_PROJECT_ALLOCATION,
        actions: { ...modifyData },
      },
      'EDR Employee Effort': {
        module: MODULE_NAMES.MIS_EDR_EMPLOYEE_EFFORT,
        actions: { ...modifyData },
      },
      'EDR Project Effort': {
        module: MODULE_NAMES.MIS_EDR_PROJECT_EFFORT,
        actions: { ...modifyData },
      },
      'EDR Activity Report': {
        module: MODULE_NAMES.MIS_EDR_ACTIVITY_REPORT,
        actions: { ...modifyData },
      },
      'Employee Utilization': {
        module: MODULE_NAMES.MIS_EMPLOYEE_UTILIZATION_REPORT,
        actions: { ...modifyData },
      },
      'Activity Report': {
        module: MODULE_NAMES.MIS_ACTIVITY_REPORT,
        actions: { ...modifyData },
      },
      'Time Sheet MIS': {
        module: MODULE_NAMES.MIS_TIME_SHEET,
        actions: { ...modifyData },
      },
      'T&M Billing Efforts': {
        module: MODULE_NAMES.MIS_BILLING_REPORT,
        actions: { ...modifyData },
      },
      'T&M Billing Effort Amount Addition': {
        module: MODULE_NAMES.MIS_BILLING_REPORT_AMOUNT_ADDITION,
        actions: { ...modifyData },
      },
      'T&M Billing Efforts Approval History': {
        module: MODULE_NAMES.MIS_BILLING_REPORT_APPROVAL_HISTORY,
        actions: {
          View: 'read',
          Edit: 'update',
          Delete: 'delete',
        },
      },
      'Delivery Utilization': {
        module: MODULE_NAMES.MIS_DELIVERY_UTILIZATION_REPORT,
        actions: { ...modifyData },
      },
      'Project Utilization': {
        module: MODULE_NAMES.MIS_PROJECT_UTILIZATION,
        actions: { ...modifyData },
      },
      'Milestone MIS': {
        module: MODULE_NAMES.MIS_MILESTONE,
        actions: { ...modifyData },
      },
      'PO MIS': {
        module: MODULE_NAMES.PO_MIS,
        actions: { ...modifyData },
      },
      'Revenue MIS': {
        module: MODULE_NAMES.MIS_REVENUE_MIS,
        actions: { ...modifyData },
      },
      'Accrued Revenue Report': {
        module: MODULE_NAMES.MIS_ACCRUED_REVENUE_REPORT,
        actions: { ...modifyData },
      },
      'Revenue Recognition': {
        module: MODULE_NAMES.MIS_REVENUE_RECOGNITION,
        actions: { ...modifyData },
      },
      'IRD': {
        module: MODULE_NAMES.MIS_IMD_VIEW,
        actions: { ...modifyData },
      },
      'Collection Report': {
        module: MODULE_NAMES.MIS_COLLECTION_REPORT,
        actions: { ...modifyData },
      },
      'Project Cost Report': {
        module: MODULE_NAMES.MIS_PROJECT_COST_REPORT,
        actions: { ...modifyData },
      },
      'Offering Wise Report': {
        module: MODULE_NAMES.MIS_OFFERING_WISE_REPORT,
        actions: { ...modifyData },
      },
      'Project Employee Cost Report': {
        module: MODULE_NAMES.MIS_FINANCE_REPORT,
        actions: { ...modifyData },
      },
      'Reseller Report': {
        module: MODULE_NAMES.MIS_RESELLER_REPORT,
        actions: { ...modifyData },
      },
      'Staff Aug Report': {
        module: MODULE_NAMES.MIS_STAFF_AUG_REPORT,
        actions: { ...modifyData },
      },
      'Risk Register': {
        module: MODULE_NAMES.MIS_RISK_REGISTER,
        actions: { ...modifyData },
      },
      'Health Check': {
        title: 'Health Check',
        active: false,
        content: {
          PMO: {
            module: MODULE_NAMES.MIS_HEALTH_CHECK_PMO,
            actions: { ...modifyData },
          },
          Architecture: {
            module: MODULE_NAMES.MIS_HEALTH_CHECK_ARCHITECTURE,
            actions: { ...modifyData },
          },
        },
      },
      'CSAT Customer Details': {
        module: MODULE_NAMES.MIS_CSAT_CUSTOMER_DETAILS,
        actions: { ...modifyData },
      },
      'AI Tool MIS': {
        module: MODULE_NAMES.MIS_AI_TOOL_MIS,
        actions: { ...modifyData },
      },
      'CSAT History': {
        module: MODULE_NAMES.MIS_CSAT_HISTORY,
        actions: { ...modifyData },
      },
      'Change Request': {
        module: MODULE_NAMES.MIS_CHANGE_REQUEST,
        actions: { ...modifyData },
      },
      'Estimation Vs Actual Report': {
        module: MODULE_NAMES.MIS_ESTIMATED_VS_ACTUAL_REPORT,
        actions: { ...modifyData },
      },

      'Staffing MIS': {
        module: MODULE_NAMES.MIS_STAFFING_MIS,
        actions: { ...modifyData },
      },
      'People Vs Project Count': {
        module: MODULE_NAMES.PEOPLE_VS_PROJECT_COUNT,
        actions: { ...modifyData },
      },
      'Gross Margin Report': {
        module: MODULE_NAMES.MIS_GROSS_MARGIN_REPORT,
        actions: { ...modifyData },
      },
      'Role Ratio Report': {
        module: MODULE_NAMES.MIS_ROLE_RATIO_REPORT,
        actions: { ...viewEditData },
      },
      'Project Wise Salary Report': {
        module: MODULE_NAMES.PROJECT_WISE_SALARY_REPORT,
        actions: { ...modifyData },
      },
      'Project Wise Expense Report': {
        module: MODULE_NAMES.PROJECT_WISE_EXPENSE_REPORT,
        actions: { ...modifyData },
      },
      'Milestone Report': {
        module: MODULE_NAMES.MILESTONE_REPORT,
        actions: { ...modifyData },
      },
    },
  },
  Finance: {
    title: 'Finance',
    active: false,
    content: {
      Milestone: {
        title: 'Milestone',
        active: false,
        content: {
          'Milestone Section': {
            module: MODULE_NAMES.FINANCE_MILESTONE,
            actions: { ...modifyData },
          },
          'PO Number': {
            module: MODULE_NAMES.FINANCE_MILESTONE_PO_NUMBER_VIEW,
            actions: { ...modifyData },
          },
          'PO Link': {
            module: MODULE_NAMES.FINANCE_MILESTONE_PO_LINK_VIEW,
            actions: { ...modifyData },
          },
          'Replanned Due Date': {
            module: MODULE_NAMES.FINANCE_MILESTONE_REPLANNED_DUE_DATE_VIEW,
            actions: { ...modifyData },
          },
          'Milestone Invoice Amount': {
            module: MODULE_NAMES.FINANCE_MILESTONE_INVOICE_AMOUNT_VIEW,
            actions: { ...modifyData },
          },
          'Milestone Amount': {
            module: MODULE_NAMES.FINANCE_MILESTONE_AMOUNT_VIEW,
            actions: { ...modifyData },
          },
          'Milestone Received Date': {
            module: MODULE_NAMES.FINANCE_MILESTONE_RECEIVED_DATE_VIEW,
            actions: { ...modifyData },
          },
          'Milestone Remarks': {
            module: MODULE_NAMES.FINANCE_MILESTONE_REMARKS_VIEW,
            actions: { ...modifyData },
          },
          'Collection Amount': {
            module: MODULE_NAMES.FINANCE_MILESTONE_COLLECTION_AMOUNT_VIEW,
            actions: { ...modifyData },
          },
          'Collection Date': {
            module: MODULE_NAMES.FINANCE_MILESTONE_COLLECTION_DATE_VIEW,
            actions: { ...modifyData },
          },
        },
      },
      'Client Details': {
        module: MODULE_NAMES.FINANCE_CLIENT_DETAILS,
        actions: { ...modifyData },
      },
      'Po Details': {
        module: MODULE_NAMES.FINANCE_PO_DETAILS,
        actions: { ...modifyData },
      },
      'Zoho Invoice Details': {
        module: MODULE_NAMES.FINANCE_ZOHO_INVOICE_DETAILS,
        actions: { ...modifyData },
      },
      'Zoho Client Details': {
        module: MODULE_NAMES.FINANCE_ZOHO_CUSTOMER_DETAILS,
        actions: { ...modifyData },
      },
      'Employee Cost Details': {
        module: MODULE_NAMES.FINANCE_EMPLOYEE_COST,
        actions: { ...modifyData },
      },
    },
  },
  Resource: {
    title: 'Resource',
    active: false,
    content: {
      'Resource Allocation': {
        module: MODULE_NAMES.RESOURCE_RESOURCE_ALLOCATION,
        actions: { ...modifyData },
      },
      'Resource Management': {
        module: MODULE_NAMES.RESOURCE_RESOURCE_MANAGEMENT,
        actions: { ...modifyData },
      },
      'Tbh Resource Management': {
        module: MODULE_NAMES.TBH_RESOURCE_MANAGEMENT,
        actions: { ...modifyData },
      },
      'Employee Management': {
        module: MODULE_NAMES.EMPLOYEE_MANAGEMENT_HISTORY,
        actions: { ...modifyData },
      },
      'TBH Employee Management': {
        module: MODULE_NAMES.RESOURCE_TBH_EMPLOYEE_MANAGEMENT,
        actions: { ...modifyData },
      },
      'Manage Employee History': {
        module: MODULE_NAMES.MANAGE_EMPLOYEE_HISTORY,
        actions: { ...modifyData },
      },
      'Project Rights': {
        module: MODULE_NAMES.RESOURCE_PROJECT_RIGHTS,
        actions: { ...modifyData },
      },
    },
  },
  StaffAugmentation: {
    title: 'Staff Augmentation',
    active: false,
    content: {
      Requirement: {
        module: MODULE_NAMES.STAFF_AUG_REQ_STATUS,
        actions: { ...modifyData },
      },
      'Project Resourcing': {
        module: MODULE_NAMES.STAFF_AUG_PROJECT_RESOURCING,
        actions: { ...modifyData },
      },
      'Clone Requirement': {
        module: MODULE_NAMES.STAFF_AUG_CLONE_REQUIREMENT,
        actions: { ...modifyData },
      },
      'Resume Generation': {
        title: 'Resume Generation',
        active: false,
        content: {
          'View Resume Details': {
            module: MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME,
            actions: { ...modifyData },
          },
          'Generate Resume': {
            module: MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_GENERATE_RESUME,
            actions: { ...modifyData },
          },
          'Upload Resume': {
            module: MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_UPLOAD_RESUME,
            actions: { ...modifyData },
          },
          'Convert to Niveus Format': {
            module: MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_CONVERT_TO_NIVEUS,
            actions: { ...modifyData },
          },
          'Edit Resume': {
            module: MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_EDIT_RESUME,
            actions: { ...modifyData },
          },
          'Download Resume': {
            module: MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_DOWNLOAD_RESUME,
            actions: { ...modifyData },
          },
        },
      },
    },
  },
  DealTransition: {
    title: 'Deal Transition',
    active: false,
    content: {
      'Dashboard': {
        module: MODULE_NAMES.DEAL_TRANSITION_DASHBOARD,
        actions: { ...modifyData },
      },
      'Custom Workflow': {
        module: MODULE_NAMES.DEAL_TRANSITION_WORKFLOW,
        actions: { ...modifyData },
      },
      'Deal SLA override': {
        module: MODULE_NAMES.DEAL_TRANSITION_SLA_OVERRIDE,
        actions: { ...modifyData },
      },
      'Staffing Projections': {
        module: MODULE_NAMES.DEAL_TRANSITION_STAFFING,
        actions: { ...modifyData },
      },
      'Revenue': {
        module: MODULE_NAMES.DEAL_TRANSITION_REVENUE,
        actions: { ...modifyData },
      },
      'Deal Approval': {
        title: 'Deal Approval',
        active: false,
        content: {
          'Deal Effort Approval': {
            module: MODULE_NAMES.DEAL_TRANSITION_DEAL_EFFORT_APPROVAL,
            actions: { ...modifyData },
          },
          'Deal Financial Approval': {
            module: MODULE_NAMES.DEAL_TRANSITION_DEAL_FINANCIAL_APPROVAL,
            actions: { ...modifyData },
          },
        },
      },
      'Deal Detail-Commercials': {
        module: MODULE_NAMES.DEAL_TRANSITION_DETAIL_COMMERCIALS,
        actions: { ...modifyData },
      },
      'Effort Estimation': {
        module: MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION,
        actions: { ...modifyData },
      },
      'Commercial Projections': {
        module: MODULE_NAMES.DEAL_TRANSITION_COMMERCIAL_PROJECTIONS,
        actions: { ...modifyData },
      },
      'Deal-Assign': {
        module: MODULE_NAMES.DEAL_TRANSITION_DEAL_ASSIGN,
        actions: { ...modifyData },
      },
      'Deal-Status Change': {
        module: MODULE_NAMES.DEAL_TRANSITION_DEAL_STATUS_CHANGE,
        actions: { ...modifyData },
      },
    },
  },
  OrganizationContribution: {
    title: 'Organization Contribution',
    active: false,
    content: {
      'Tech Session': {
        title: 'Tech Session',
        active: false,
        content: {
          Calendar: {
            module: MODULE_NAMES.TECH_SESSION_CALENDAR,
            actions: { ...modifyData },
          },
          Users: {
            module: MODULE_NAMES.TECH_SESSION_NEW_REQUEST,
            actions: { ...modifyData },
          },
          'Received Request': {
            module: MODULE_NAMES.TECH_SESSION_RECEIVED_REQUEST,
            actions: { ...modifyData },
          },
        },
      },
      Blogs: {
        module: MODULE_NAMES.ORGANIZATION_BLOGS,
        actions: { ...modifyData },
      },
    },
  },
};

// disable tasks actions for certain modules
export const disableTask = (module, task) => {
  const deleteTasks = [MODULE_NAMES.CERTIFICATION_TARGET, MODULE_NAMES.CONFIGURATION_MANAGE_KPI,MODULE_NAMES.CONFIGURATION_CLOUD_PROVIDER, MODULE_NAMES.CONFIGURATION_BILLING_TYPE, MODULE_NAMES.MASTER_PERFORMANCE_PERIOD, MODULE_NAMES.CONFIGURATION_EFFORT_UPLOAD, MODULE_NAMES.CONFIGURATION_LEAVE_UPLOAD, MODULE_NAMES.DEAL_TRANSITION_DASHBOARD, MODULE_NAMES.DEAL_TRANSITION_DEAL_EFFORT_APPROVAL, MODULE_NAMES.DEAL_TRANSITION_DEAL_FINANCIAL_APPROVAL, MODULE_NAMES.MIS_STAFF_AUG_REPORT, MODULE_NAMES.TECH_SESSION_CALENDAR, MODULE_NAMES.TECH_SESSION_NEW_REQUEST, MODULE_NAMES.TECH_SESSION_RECEIVED_REQUEST, MODULE_NAMES.STAFF_AUG_CLONE_REQUIREMENT, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_GENERATE_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_CONVERT_TO_NIVEUS, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_UPLOAD_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_EDIT_RESUME, MODULE_NAMES.PROJECT_FILE_UPLOAD_REDMINE, MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE, MODULE_NAMES.PROJECT_FILE_UPLOAD_HOLIDAY, MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE_TEST, MODULE_NAMES.PROJECT_FILE_UPLOAD_SALARY, MODULE_NAMES.PROJECT_FILE_UPLOAD_PROJECT_EXPENSE, MODULE_NAMES.PROJECT_FILE_UPLOAD_JIRA, MODULE_NAMES.MIS_HEALTH_CHECK_PMO, MODULE_NAMES.DELIVERY_PROJECT_DETAILS_EDIT, MODULE_NAMES.DELIVERY_PROJECT_MANAGER_DETAILS_EDIT, MODULE_NAMES.MIS_MILESTONE, MODULE_NAMES.MASTER_ALLOCATION_STAKE_HOLDERS,MODULE_NAMES.MASTERS_REGION_LIST, MODULE_NAMES.MASTERS_COUNTRY_LIST,
    MODULE_NAMES.CONFIGURATION_DEPARTMENT_LIST, MODULE_NAMES.MASTERS_DELIVERY_METHODOLGY,
    MODULE_NAMES.CONFIGURATION_EMPLOYEE_EXPERIENCE, MODULE_NAMES.CONFIGURATION_INVOICE_PAYMENT_STATUS, MODULE_NAMES.CONFIGURATION_EMPLOYEE_VERTICAL, MODULE_NAMES.CONFIGURATION_INVOICE_STATUS, MODULE_NAMES.MASTERS_INVOICE_TYPE,
    MODULE_NAMES.CONFIGURATION_ISSUE_CATEGORY, MODULE_NAMES.CONFIGURATION_ISSUE_STATUS
  ];
  const addEditDeleteTasks = [MODULE_NAMES.HOME_DASHBOARD,MODULE_NAMES.CERTIFICATION_OVERVIEW, MODULE_NAMES.EMPLOYEE_ONBOARDING, MODULE_NAMES.EMPLOYEE_TRAINING, MODULE_NAMES.EMPLOYEE_PERFORMANCE, MODULE_NAMES.GENERAL_CONFIG_SEARCH, MODULE_NAMES.MIS_HEALTH_CHECK_ARCHITECTURE, MODULE_NAMES.FINANCE_MILESTONE_INVOICE_AMOUNT_VIEW, MODULE_NAMES.MIS_RESELLER_REPORT, MODULE_NAMES.MIS_COLLECTION_REPORT, MODULE_NAMES.MIS_DELIVERY_UTILIZATION_REPORT, MODULE_NAMES.MIS_REVENUE_RECOGNITION, MODULE_NAMES.MIS_PROJECT_UTILIZATION, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_DOWNLOAD_RESUME, MODULE_NAMES.MIS_EMPLOYEE_UTILIZATION_REPORT, MODULE_NAMES.MIS_ACTIVITY_REPORT, MODULE_NAMES.MIS_EDR_EMPLOYEE_EFFORT, MODULE_NAMES.MIS_EDR_PROJECT_EFFORT,
    MODULE_NAMES.DELIVERY_PROJECT_DETAILS_UTILIZATION,
  MODULE_NAMES.MIS_EMPLOYEE_DETAILS,
  MODULE_NAMES.PO_MIS,
  MODULE_NAMES.DELIVERY_PROJECT_UNIT_AMOUNT,
  MODULE_NAMES.DELIVERY_PROJECT_DETAILS_CUSTOMER_TYPE,
  MODULE_NAMES.DELIVERY_PROJECT_DETAILS_VG_NVG,
  MODULE_NAMES.DELIVERY_PROJECT_DETAILS_EFFORT_LOGGING,
  MODULE_NAMES.DELIVERY_PROJECT_DETAILS_JIRA_PROJECT_ID,
  MODULE_NAMES.DELIVERY_PROJECT_DETAILS_PROJECT_DL,
  MODULE_NAMES.FINANCE_MILESTONE_PO_NUMBER_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_PO_LINK_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_REPLANNED_DUE_DATE_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_INVOICE_AMOUNT_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_AMOUNT_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_RECEIVED_DATE_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_REMARKS_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_COLLECTION_AMOUNT_VIEW,
  MODULE_NAMES.FINANCE_MILESTONE_COLLECTION_DATE_VIEW,
  MODULE_NAMES.MIS_FINANCE_REPORT,
  MODULE_NAMES.MIS_TIME_SHEET,
  MODULE_NAMES.MIS_ALLOCATION_MIS,
  MODULE_NAMES.MIS_OFFERING_WISE_REPORT,
  MODULE_NAMES.MIS_PROJECT_COST_REPORT,
  MODULE_NAMES.TBH_RESOURCE_MANAGEMENT,
  MODULE_NAMES.MANAGE_EMPLOYEE_HISTORY,
  MODULE_NAMES.MIS_ESTIMATED_VS_ACTUAL_REPORT,
  MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW,
  MODULE_NAMES.PEOPLE_VS_PROJECT_COUNT,
  MODULE_NAMES.MIS_PROJECT_ALLOCATION,
  MODULE_NAMES.PROJECT_WISE_SALARY_REPORT,
  MODULE_NAMES.PROJECT_WISE_EXPENSE_REPORT,
  MODULE_NAMES.MIS_GROSS_MARGIN_REPORT,
  MODULE_NAMES.MILESTONE_REPORT,
  MODULE_NAMES.MIS_STAFFING_MIS,
  ];
  const editTasks = [MODULE_NAMES.EMPLOYEE_ACHIEVEMENTS, MODULE_NAMES.EMPLOYEE_PROJECTS, MODULE_NAMES.DEAL_TRANSITION_DEAL_EFFORT_APPROVAL, MODULE_NAMES.DEAL_TRANSITION_DEAL_FINANCIAL_APPROVAL, MODULE_NAMES.TECH_SESSION_CALENDAR, MODULE_NAMES.TECH_SESSION_NEW_REQUEST, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_GENERATE_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_CONVERT_TO_NIVEUS, MODULE_NAMES.PROJECT_FILE_UPLOAD_REDMINE, MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE, MODULE_NAMES.PROJECT_FILE_UPLOAD_HOLIDAY, MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE_TEST, MODULE_NAMES.PROJECT_FILE_UPLOAD_SALARY, MODULE_NAMES.PROJECT_FILE_UPLOAD_PROJECT_EXPENSE, MODULE_NAMES.PROJECT_FILE_UPLOAD_JIRA, MODULE_NAMES.DELIVERY_ADD_STAFFING_REQUEST];
  const viewEditTasks = [MODULE_NAMES.DEAL_TRANSITION_DASHBOARD, MODULE_NAMES.DEAL_TRANSITION_DEAL_ASSIGN, MODULE_NAMES.MASTER_DEAL_STATUS, MODULE_NAMES.CONFIGURATION_DATE_CONFIG, MODULE_NAMES.DELIVERY_STATUS_HISTORY_APPROVAL];
  const allTasks = [MODULE_NAMES.DEAL_TRANSITION_STAFFING, MODULE_NAMES.DEAL_TRANSITION_WORKFLOW, MODULE_NAMES.DEAL_TRANSITION_REVENUE, MODULE_NAMES.DEAL_TRANSITION_COMMERCIAL_PROJECTIONS,
  MODULE_NAMES.DEAL_TRANSITION_SLA_OVERRIDE, MODULE_NAMES.DEAL_TRANSITION_DEAL_STATUS_CHANGE]; // disabled since incomplete dealTransiton modules
  const addTasks = [MODULE_NAMES.MIS_STAFF_AUG_REPORT, MODULE_NAMES.TECH_SESSION_RECEIVED_REQUEST, MODULE_NAMES.STAFF_AUG_CLONE_REQUIREMENT, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_UPLOAD_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_EDIT_RESUME, MODULE_NAMES.MIS_HEALTH_CHECK_PMO, MODULE_NAMES.DELIVERY_PROJECT_MANAGER_DETAILS_EDIT, MODULE_NAMES.DELIVERY_RESOURCE_LOADING_APPROVAL_HISTORY];
  const viewTasks = [MODULE_NAMES.STAFF_AUG_CLONE_REQUIREMENT, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_GENERATE_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_UPLOAD_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_EDIT_RESUME, MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_CONVERT_TO_NIVEUS];
  const viewUpdateTasks = [MODULE_NAMES.AI_ACCESS_REQUEST_APPROVAL];
  const staffingRequestViewOnlyDisabledTasks = [MODULE_NAMES.DELIVERY_ADD_STAFFING_REQUEST_APPROVAL];

  return (
    (deleteTasks.includes(module) && task === 'Delete') ||
    (addEditDeleteTasks.includes(module) && ['Add', 'Edit', 'Delete'].includes(task)) ||
    (editTasks.includes(module) && task === 'Edit') ||
    (viewEditTasks.includes(module) && ['Add', 'Delete'].includes(task)) ||
    (viewUpdateTasks.includes(module) && ['View', 'Update'].includes(task)) ||
    (addTasks.includes(module) && task === 'Add') ||
    (allTasks.includes(module) && ['View', 'Add', 'Edit', 'Delete'].includes(task)) || // disabled since incomplete dealTransiton modules for production
    (viewTasks.includes(module) && task === 'View') ||
    (staffingRequestViewOnlyDisabledTasks.includes(module) && ['View', 'Add', 'Delete'].includes(task))
  );
};
